// removed by extract-text-webpack-plugin
module.exports = {"main-container":"wJX3UvwMhpUXTClLB8b6A"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TripDetail/TripDetail.scss
// module id = 1282
// module chunks = 0